import { takeEvery, put, call, SagaReturnType } from 'redux-saga/effects';
import { DashboardConstants } from 'src/redux/actions/constant';
import dashboardServices from 'src/services/apiServices/dashboard-services/dashboard-services';

const {
  GET_AUTO_CLOCK_OUT_CALL_REQUEST,
  GET_AUTO_CLOCK_OUT_CALL_SUCCESS,
  GET_AUTO_CLOCK_OUT_CALL_FAILURE,
} = DashboardConstants;

function* getAutoClockOut(action: any): SagaReturnType<any> {
  try {
    const response = yield call(dashboardServices.getAutoClockOutCall, action.payload);
    if (response?.status === 200) {
      yield put({ type: GET_AUTO_CLOCK_OUT_CALL_SUCCESS, payload: response.data });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: GET_AUTO_CLOCK_OUT_CALL_FAILURE, payload: error });
  }
}

function* getAutoClockOutSaga() {
  yield takeEvery(GET_AUTO_CLOCK_OUT_CALL_REQUEST, getAutoClockOut);
}

export default getAutoClockOutSaga;
